import React from "react";

const formatPrice = (price, currency = "CHF") => {
  // Vérifier si price est défini et le convertir en nombre si nécessaire
  if (price === undefined || price === null) {
    return `0,00 ${currency}`;
  }

  // Convertir en nombre flottant
  const numericPrice = parseFloat(price);

  // Vérifier si la conversion a réussi (n'est pas NaN)
  if (isNaN(numericPrice)) {
    return `0,00 ${currency}`;
  }

  // Formater le prix avec deux décimales et remplacer le point par une virgule
  return `${numericPrice.toFixed(2).replace(".", ",")} ${currency}`;
};

export default formatPrice;
